import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GradientConfig} from '../../../../app-config';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  public gradientConfig: any;
  public menuClass: boolean;
  public collapseStyle: string;
  public windowWidth: number;

  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavHeaderMobCollapse = new EventEmitter();
  @Output() openNotificationBox = new EventEmitter();

  constructor(        private translateService: TranslateService,
    ) {
    this.gradientConfig = GradientConfig.config;
    this.menuClass = false;
    this.collapseStyle = 'none';
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {
    // .get('appTitle')
    // .subscribe((message) => {
    //   console.log('message',message);
    //   //  this.messageService.add(message);
    // });

  }

  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.collapseStyle = (this.menuClass) ? 'block' : 'none';
  }

  navCollapse() {
    if (this.windowWidth >= 992) {
      this.onNavCollapse.emit();
    } else {
      this.onNavHeaderMobCollapse.emit();
    }
  }

  openNotificationPanel(event) {
    console.log(event)
    this.openNotificationBox.emit(event);
  }
}
